var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('single-line-text-input-block',{attrs:{"config":_vm.config,"parent-feature":_vm.parentFeature,"validation-methods":{ isValidEmail: _vm.isValidEmail },"disabled":_vm.disabled,"disabledReason":_vm.disabledReason}})
}
var staticRenderFns = []

export { render, staticRenderFns }